import { Component } from '@angular/core';

@Component({
  selector: 'app-web-layout',
  template: `
    <div class="web-layout">
      <div class="header main-content">
        <app-header></app-header>
      </div>
      <main class="main-content">
        <router-outlet></router-outlet>
      </main>
    </div>
  `,
  styles: [`
    .web-layout {
      min-height: 100vh;
      display: flex;
      flex-direction: column;
      background: linear-gradient(180deg, #29262D 0%, #110F13 100%);
    }

    .main-content {
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
      padding-left: 20px;
      padding-right: 20px;
    }

    @media screen and (max-width: 1024px) {
      .header {
          padding-left: 40px;
          padding-right: 40px;
      }
    }

    @media screen and (max-width: 768px) {
      .header {
          padding-left: 16px;
          padding-right: 16px;
      }
    }
  `]
})
export class WebLayoutComponent { }
